import { render, staticRenderFns } from "./CompensationPointsRestore.vue?vue&type=template&id=6ae31b2f&scoped=true&"
import script from "./CompensationPointsRestore.vue?vue&type=script&lang=js&"
export * from "./CompensationPointsRestore.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ae31b2f",
  null
  
)

export default component.exports